<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">
  <!-- 기본게시판 //-->
  <table class="hlist-table hlist-table1">
  <colgroup>
    <col class="col1">
    <col class="col2">
    <col class="col3">
    <col class="col4">
    <col class="col5">
  </colgroup>

  <thead>
  <tr>
    <th scope="col">번호</th>
    <th scope="col">결제일시</th>
    <th scope="col">결제수단</th>
    <th scope="col">결제금액</th>
    <th scope="col">결제정보</th>
  </tr>
  </thead>

  <tbody>
  <tr *ngFor="let row of memberPaymentList; index as i">
    <td>{{totalCount - ( ( ( params.no - 1 ) * params.row ) + i )}}</td>
    <td>
      <a class="cp">{{row.appDateFormat || row.applicationDate}}</a>
    </td>
    <td>{{row.payMethodName}}</td>
    <td>{{row.payAmt | currency:'KRW':'symbol'}}</td>
    <td>
      <ng-container *ngIf="row.cardName !== null">({{row.cardName}}) {{row.cardNum}}</ng-container>
    </td>
  </tr>
  </tbody>
  </table>

  <div class="pagination-area">
    <ngb-pagination *ngIf="totalCount > 0"
      [(page)]="params.no"
      [pageSize]="params.row"
      [maxSize]="maxSize"
      [collectionSize]="totalCount"
      [boundaryLinks]="true"
      rotate="true"
      (pageChange)="loadPage($event)"
      >
      <ng-template ngbPaginationFirst>&lt;&lt;</ng-template>
      <ng-template ngbPaginationLast>&gt;&gt;</ng-template>
      <ng-template ngbPaginationPrevious>&lt;</ng-template>
      <ng-template ngbPaginationNext>&gt;</ng-template>
    </ngb-pagination>
  </div>

</div>

<app-footer></app-footer>
